import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import DiscussionTextarea from './DiscussionTextarea';

const DiscussionQuestion = props => {
  const { id, required } = props;
  return (
    <QuestionWrapper {...props}>
      <DiscussionTextarea
        name={`questions[${props.name}]`}
        questionId={id}
        required={required}
        disableCopyPaste={props.survey?.disable_copy_paste}
      />
    </QuestionWrapper>
  );
};

DiscussionQuestion.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  text: PropTypes.string.isRequired,
};

DiscussionQuestion.defaultProps = {
  number_of_fields: 1,
};

export default DiscussionQuestion;
